/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { logout } from '@upright/ui/untidy/redux/actions/actions';
import { loggedInUser } from '@upright/ui/untidy/redux/selectors';
import { NewInterfaceSwitch } from '../../../new-interface-switch';
import { Item, ItemLink, MenuTitleSmall } from '../../shared-menus';
import { SignedInAs } from './signed-in-as';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';

export function AccountBlock() {
  return (
    <Root>
      <MenuTitleSmall>Account</MenuTitleSmall>
      <Items />
    </Root>
  );
}

function Items() {
  const user = useSelector(loggedInUser);
  const dispatch = useDispatch();
  const handleLogout = () => dispatch(logout());

  if (user) {
    return (
      <>
        <SignedInAs />
        {/* PLT-7968: the phone's way back to the new interface, since this menu is the only
            account menu the old interface has on a phone. */}
        <MobileNewInterfaceSwitch />
        <Item>
          <ItemLink id={E2eTestElementId.MOBILE_LOGOUT} to="" onClick={handleLogout}>
            Logout
          </ItemLink>
        </Item>
      </>
    );
  }
  return (
    <>
      <Item>
        <ItemLink to="/login" id={E2eTestElementId.MOBILE_LOGIN}>
          Login
        </ItemLink>
      </Item>
    </>
  );
}

const Root = styled.div``;

const MobileNewInterfaceSwitch = styled(NewInterfaceSwitch)`
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
`;
